import {
    confirmPasswordResetApiV1AuthPasswordResetConfirmPost,
    validateResetTokenApiV1AuthPasswordResetValidatePost,
} from '@/common/api/client/sdk.gen'
import type {
    ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostData,
    ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostError,
    ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostResponse,
    ValidateResetTokenApiV1AuthPasswordResetValidatePostData,
    ValidateResetTokenApiV1AuthPasswordResetValidatePostResponse,
} from '@/common/api/client/types.gen'
import { useFormMutation } from '@/common/hooks/useFormMutation'
import { useEffect, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ROUTES, RESET_TOKEN_ERROR } from '../lib/constants'

export const useResetPassword = () => {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const reset_token = searchParams.get('token')
    const [isValidToken, setValidToken] = useState(false)

    const { mutation, onSubmit, register, handleSubmit, errors, setError, setValue } = useFormMutation<
        ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostData['body'],
        ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostResponse,
        ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostError
    >({
        mutationFn: data => confirmPasswordResetApiV1AuthPasswordResetConfirmPost({ body: data }).then(r => r.data!),
        toastOptions: {
            successMessage: 'Пароль успешно изменен',
            errorMessage: 'Ошибка при сбросе пароля',
        },
        onSuccess: () => navigate(ROUTES.APP),
        onError: () => setError('root', { type: 'server', message: 'Ошибка при сбросе пароля' }),
    })

    const { mutate: validateResetTokenMutate } = useMutation<
        ValidateResetTokenApiV1AuthPasswordResetValidatePostResponse,
        Error,
        ValidateResetTokenApiV1AuthPasswordResetValidatePostData['body']
    >({
        mutationFn: data => validateResetTokenApiV1AuthPasswordResetValidatePost({ body: data }).then(r => r.data!),
        onSuccess: ({ error, valid }) => {
            setValidToken(valid)
            if (error === RESET_TOKEN_ERROR.EXPIRED) {
                setError('root', { type: 'server', message: RESET_TOKEN_ERROR.EXPIRED })
            }
            if (valid && reset_token) setValue('reset_token', reset_token)
        },
        onError: () => setValidToken(false),
    })

    useEffect(() => {
        if (reset_token) validateResetTokenMutate({ reset_token })
    }, [reset_token, validateResetTokenMutate])

    return {
        register,
        handleSubmit,
        errors,
        onSubmit,
        mutation,
        isValidToken,
    }
}
